import "bootstrap/dist/css/bootstrap.css";

import Header from "../views/components/Header/Header";
import SideNavbar from "../views/components/SideNavBar/SideNavbar";
import "../styles/layout/layout.scss";
import { Outlet, useLocation } from "react-router-dom";

const Layout = () => {
  const location = useLocation();

  if (location.pathname.includes("/meal-plan"))
    return (
      <>
        <Header />
        <Outlet />
      </>
    );

  return (
    <>
      <Header />
      <div className="container-lg my-4">
        <div className="row">
          <div className="col-md-2">
            <SideNavbar />
          </div>
          <div className="col-md-10 ps-0">
            <Outlet />
          </div>
        </div>
      </div>
    </>
  );
};

export default Layout;
